export const LEFT_HAND_POINTING = [
  {t: [-0.0283, -0.0376, -0.0293], r: [0.1372, -0.208, 0.241, 0.938]},
  {t: [0.0016, -0.0246, -0.0431], r: [0.0106, -0.3992, -0.0014, 0.9168]},
  {t: [0.0392, -0.0237, -0.0781], r: [-0.1, -0.2869, -0.466, 0.831]},
  {t: [0.0496, -0.0357, -0.1004], r: [-0.1511, -0.183, -0.4918, 0.8377]},
  {t: [0.0533, -0.0497, -0.1265], r: [-0.1511, -0.183, -0.4918, 0.8377]},
  {t: [-0.0078, -0.0226, -0.0496], r: [0.1168, -0.3031, 0.3253, 0.8881]},
  {t: [0.0265, 0.0074, -0.1082], r: [0.0563, -0.1303, 0.2725, 0.9516]},
  {t: [0.0346, 0.0153, -0.1453], r: [-0.0635, -0.1606, 0.2541, 0.9516]},
  {t: [0.0419, 0.0144, -0.1659], r: [-0.1073, -0.1342, 0.2464, 0.9538]},
  {t: [0.0494, 0.0105, -0.1873], r: [-0.1073, -0.1342, 0.2464, 0.9538]},
  {t: [-0.0184, -0.0273, -0.0562], r: [0.1156, -0.2249, 0.3238, 0.9117]},
  {t: [0.0052, -0.0021, -0.1177], r: [-0.4452, -0.2871, 0.2041, 0.8233]},
  {t: [0.0324, -0.0274, -0.1363], r: [0.8476, 0.3909, 0.031, -0.3574]},
  {t: [0.0392, -0.0465, -0.1142], r: [0.9167, 0.3645, 0.16, -0.0352]},
  {t: [0.032, -0.0501, -0.0915], r: [0.9167, 0.3645, 0.16, -0.0352]},
  {t: [-0.028, -0.0348, -0.0593], r: [0.0757, -0.1724, 0.308, 0.9326]},
  {t: [-0.01, -0.0186, -0.1201], r: [-0.5151, -0.3075, 0.2332, 0.7654]},
  {t: [0.018, -0.0439, -0.1306], r: [0.8841, 0.4115, 0.0419, -0.2175]},
  {t: [0.0214, -0.0572, -0.1026], r: [0.8915, 0.3885, 0.1955, 0.1266]},
  {t: [0.0111, -0.0549, -0.0835], r: [0.8915, 0.3885, 0.1955, 0.1266]},
  {t: [-0.0357, -0.0434, -0.0601], r: [0.0242, -0.0998, 0.3079, 0.9459]},
  {t: [-0.0254, -0.037, -0.1183], r: [-0.4608, -0.35, 0.2807, 0.7658]},
  {t: [0.0022, -0.0544, -0.1281], r: [0.8346, 0.4535, 0.0038, -0.3127]},
  {t: [0.0089, -0.0663, -0.1107], r: [0.8657, 0.4769, 0.1519, -0.0059]},
  {t: [0.003, -0.0699, -0.0932], r: [0.8657, 0.4769, 0.1519, -0.0059]},
] as const;

export const RIGHT_HAND_POINTING = [
  {t: [-0.0042, -0.0248, -0.0222], r: [0.1163, -0.0095, -0.3006, 0.9466]},
  {t: [-0.024, -0.0114, -0.048], r: [-0.052, 0.2376, -0.0719, 0.9673]},
  {t: [-0.0482, -0.0149, -0.0937], r: [-0.2324, 0.2162, 0.3797, 0.869]},
  {t: [-0.0535, -0.0306, -0.1155], r: [-0.2846, 0.1212, 0.4068, 0.8595]},
  {t: [-0.0521, -0.0492, -0.1388], r: [-0.2846, 0.1212, 0.4068, 0.8595]},
  {t: [-0.0129, -0.0119, -0.0508], r: [0.1258, 0.0866, -0.3895, 0.9083]},
  {t: [-0.0173, 0.01, -0.1215], r: [0.1174, -0.0564, -0.3421, 0.9306]},
  {t: [-0.0097, 0.018, -0.1587], r: [-0.0512, 0.0028, -0.347, 0.9365]},
  {t: [-0.0105, 0.0158, -0.1805], r: [-0.1583, 0.003, -0.3458, 0.9249]},
  {t: [-0.0137, 0.0085, -0.2021], r: [-0.1583, 0.003, -0.3458, 0.9249]},
  {t: [-0.0017, -0.019, -0.052], r: [0.1155, 0.0062, -0.386, 0.9152]},
  {t: [0.0038, -0.0037, -0.1206], r: [-0.2494, 0.0619, -0.3947, 0.8822]},
  {t: [-0.0086, -0.0197, -0.1569], r: [-0.7146, 0.3231, -0.2612, 0.5628]},
  {t: [-0.0306, -0.0389, -0.1502], r: [0.8643, -0.4054, 0.1306, -0.2676]},
  {t: [-0.0406, -0.0469, -0.1297], r: [0.8643, -0.4054, 0.1306, -0.2676]},
  {t: [0.0068, -0.0279, -0.0499], r: [0.0671, -0.0438, -0.3807, 0.9212]},
  {t: [0.0155, -0.022, -0.1146], r: [-0.3096, 0.1005, -0.4385, 0.8377]},
  {t: [-0.0022, -0.0389, -0.1452], r: [0.7388, -0.369, 0.2794, -0.4899]},
  {t: [-0.0264, -0.0553, -0.1341], r: [0.852, -0.4611, 0.1257, -0.214]},
  {t: [-0.0346, -0.0602, -0.1146], r: [0.852, -0.4611, 0.1257, -0.214]},
  {t: [0.0126, -0.0374, -0.0464], r: [0.0105, -0.1129, -0.3882, 0.9146]},
  {t: [0.0254, -0.0415, -0.1045], r: [-0.3088, 0.1125, -0.4825, 0.8119]},
  {t: [0.0078, -0.0548, -0.1304], r: [-0.6368, 0.3211, -0.3767, 0.5912]},
  {t: [-0.0112, -0.0661, -0.1307], r: [0.7535, -0.4639, 0.2523, -0.3916]},
  {t: [-0.0244, -0.0737, -0.1196], r: [0.7535, -0.4639, 0.2523, -0.3916]},
] as const;
